<script lang="ts">
  import { formatDailyAverageScore, formatDistance, scoreBandEmoji } from '@atlasguess/games';
  import { displayUnit } from '../lib/units';
  import type { RecentDailyEntry } from '../lib/stats';

  // Recent daily runs table — used on the account Stats tab and the
  // public profile. Mirrors the LeaderboardTable's per-round score
  // ribbon so a player can scan their own history with the same
  // visual grammar they read on the global board: 🔵 100  🟢 88
  // (etc.) per round, with a total at the right and the day's date
  // anchoring the row at the left.

  interface Props {
    rows: RecentDailyEntry[];
  }

  let { rows }: Props = $props();

  const formatAvg = (km: number): string => formatDistance(km, $displayUnit);

  function formatDate(iso: string): string {
    // ISO YYYY-MM-DD → locale short ("Apr 29"). Use UTC parsing so the
    // displayed date matches the run_key's date suffix exactly,
    // regardless of the viewer's timezone.
    const [y, m, d] = iso.split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    return date.toLocaleDateString(undefined, {
      timeZone: 'UTC',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }
</script>

<div class="leaderboard-table-wrap">
  <table class="leaderboard-table">
    <thead>
      <tr>
        <th>Date</th>
        <th class="leaderboard-table__rounds">Rounds</th>
        <th class="leaderboard-table__num">Avg</th>
        <th class="leaderboard-table__num">Score</th>
      </tr>
    </thead>
    <tbody>
      {#each rows as row (row.date)}
        <tr>
          <td>{formatDate(row.date)}</td>
          <td class="leaderboard-table__rounds">
            <ul class="leaderboard-table__score-list" aria-label="Per-round scores">
              {#each row.scores as score, i (i)}
                <li class="leaderboard-table__score-cell">
                  <span class="leaderboard-table__score-emoji" aria-hidden="true">
                    {scoreBandEmoji(score, i)}
                  </span>
                  <span class="leaderboard-table__score-num">{score}</span>
                </li>
              {/each}
            </ul>
          </td>
          <td class="leaderboard-table__num leaderboard-table__avg">
            {formatAvg(row.avg_km)}
          </td>
          <td class="leaderboard-table__num leaderboard-table__total">
            {formatDailyAverageScore(row.total_score, row.scores.length)}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
